import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEdit, FaCrown, FaWallet, FaSyncAlt } from "react-icons/fa";
import {
  AsignPlanVendorList,
} from "../../redux/services/SubscriptionServices/Subscription.Services";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/features/modalSlice";
import { useSelector } from "react-redux";
import Pagination from "../../common/Pagination";
import { errorToast } from "../../Utils/toast";
import { formatDateTime } from "../../Utils/formatters"; // ← adjust path

import Search from "../../common/Search";
function VenderSubscriptions() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { refreshData } = useSelector(
    (state) => state.modal
  );
  const [tableLoading, setTableLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [subscription, setSubscription] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);
  const [totalLeads, setTotalLeads] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const fetchSubscriptionList = async (pageNo = 1) => {
    try {
      setTableLoading(true);
      const payload = { search, page: pageNo, per_page: limit };
      const res = await AsignPlanVendorList(payload);
      const list = Array.isArray(res?.data) ? res.data : [];
      setSubscription(list);
      setPage(res?.current_page ?? 1);
      setTotalPages(res?.last_page ?? 1);
      setTotalLeads(res?.total ?? 0);
    } catch (error) {
      console.log(error);
      errorToast("Failed to load subscription plans");
      setSubscription([]);
    } finally {
      setTableLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscriptionList(1);
  }, [limit, search]);
  const goToVendorPlans = (item) => {
    const vendorId = item?.vendor?.user_id || item?.user_id;
    if (vendorId) {
      navigate(`/view-assigned-planlist/${vendorId}`);
    }
  };
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages && !tableLoading) {
      setPage(newPage);
      fetchSubscriptionList(newPage);
    }
  };

  const formatPrice = (val) => {
    if (val === null || val === undefined || val === "") return "-";
    return `₹${Number(val).toLocaleString("en-IN")}`;
  };

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="title_member">
          <h4>Vendor Subscription List</h4>
        </div>
        <div className="d-flex flex-wrap gap-2 justify-content-end">
          <button
            className="add-btn"
            onClick={() => navigate("/asign-subscription-vendor")}
          >
            + Assign Plan
          </button>
        </div>
      </div>

      <div className="main_page">
        {(totalLeads > 0 || search) && (
          <div className="d-flex justify-content-end align-items-center mx-2 mb-2">
            <Search
              search={search}
              placeholder="Search Plan..."
              onSearch={(value) => {
                setSearch(value);
                setPage(1);
              }}
            />
          </div>
        )}

        <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Date</th>
                  <th>Name/Mobile</th>
                  <th>Module</th>
                  <th>Plan Name</th>
                  <th>Amount</th>
                  <th>Ai Call Limit</th>
                  {/* <th>Category</th> */}
                  {/* <th>Price</th> */}
                  {/* <th>Duration</th> */}
                  {/* <th>Is Paid</th> */}
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {tableLoading ? (
                  <tr>
                    <td colSpan="9" className="text-center py-3">
                      <div className="spinner-border text-primary"></div>
                    </td>
                  </tr>
                ) : subscription.length > 0 ? (
                  subscription.map((item, index) => (
                    <tr key={item.id}>
                      <td>{(page - 1) * limit + index + 1}</td>
                      <td className="text-start">
                        <small className="">
                          {formatDateTime(item?.created_at)}
                        </small>
                      </td>
                      <td>
                        {[item?.vendor?.name, item?.vendor?.mobile]
                          .filter(Boolean)
                          .join(" / ") || "-"}
                      </td>
                      
                      <td className="text-start">
                        {/* <div
                          className="fw-bold text-primary"
                          style={{ cursor: "pointer" }}
                          onClick={() => goToVendorPlans(item)}
                          title="View all plans of this vendor"
                        >
                          {item?.plan?.name || "-"}
                        </div> */}

                        <small className="fw-bold">
                          {item?.module?.name}
                        </small>

                      </td>
                      <td className="text-start">
                        <div className="fw-bold">{item?.plan?.name || "-"}</div>
                        {item?.description && (
                          <small className="text-muted">
                            {item.description}
                          </small>
                        )}
                      </td>
                      <td className="fw-bold text-success">
                        {formatPrice(item?.total_amount)}
                      </td>
                      <td className="fw-bold text-success">
                        Seconds ( {item?.plan?.ai_call_limit} )
                      </td>

                      {/* <td>{item.category.name|| "-"}</td> */}

                      {/* <td>
                        {item?.category?.name ? (
                          <span className="badge bg-info text-dark">
                            {item?.category?.name}
                          </span>
                        ) : (
                          "-"
                        )}
                      </td> */}

                      {/* <td className="fw-bold text-success">
                        {formatPrice(item?.price)}
                      </td> */}

                      {/* <td>
                        {item?.duration_days
                          ? `${item.duration_days} days`
                          : "-"}
                      </td> */}

                      {/* <td>
                        {item?.module?.is_paid === 1 ? (
                          <span className="badge bg-success">Yes</span>
                        ) : (
                          <span className="badge bg-secondary">No</span>
                        )}
                      </td> */}
                      <td>
                        {item?.status === "active" ? (
                          <span className="badge bg-success">Active</span>
                        ) : (
                          <span className="badge bg-danger text-capitalize">
                            {item?.status || "Inactive"}
                          </span>
                        )}
                      </td>
                      {/* <td>
                        <div className="city-status-switch">
                          <input
                            type="checkbox"
                            id={`status-${item.id}`}
                            className="city-status-input"
                            checked={item.status === 1}
                            onChange={() =>
                              dispatch(
                                openModal({
                                  type: "change-toggle-status",
                                  title: "Change Status",
                                  data: {
                                    id: item.id,
                                    currentStatus:
                                      item.status === 1 ? "Active" : "Inactive",
                                    // statusFunction:
                                    //   updateSubscriptionPlanStatus,
                                    onSuccess: () =>
                                      fetchSubscriptionList(page),
                                  },
                                })
                              )
                            }
                          />
                          <label
                            htmlFor={`status-${item.id}`}
                            className="city-status-label"
                          >
                            <span className="city-status-ball"></span>
                            <span className="city-status-text">
                              {item.status === 1 ? "Active" : "Inactive"}
                            </span>
                          </label>
                        </div>
                      </td> */}

                      <td className="text-center">
                        <div className="d-flex align-items-center justify-content-center gap-1">
                          <button
                            className="st-action-btn st-view-btn"
                            title="View"
                            onClick={() =>
                              navigate(`/view-assigned-planlist/${item.user_id}`)
                            }
                          >
                            <FaEye />
                          </button>



                          {/* <button
                            className="btn btn-renew"
                            onClick={() =>
                              dispatch(
                                openModal({
                                  type: "renew-subscription",
                                  title: "Renew Your Plan",
                                  data: { ...item, onSuccess: () => fetchSubscriptionList(page) },
                                })
                              )
                            }
                          >
                            Renew
                          </button>

                          <button
                            className="btn btn-upgrade"
                            onClick={() =>
                              dispatch(
                                openModal({
                                  type: "upgrade-subscription",
                                  title: "Upgrade Your Plan",
                                  data: { ...item, onSuccess: () => fetchSubscriptionList(page) },
                                })
                              )
                            }
                          >

                            Upgrade
                          </button> */}
                          {/* <button
                            className="st-action-btn st-view-btn"
                            title="View"
                            // onClick={() =>
                            //   navigate(`/plan-transaction-history/${item.user_id}`)
                            // }
                            onClick={() =>
                              navigate("/asign-plan-user", {
                                state: { subscription: item }, // ya sirf { userId: item.user_id }
                              })
                            }
                          >
                            <FaWallet />
                          </button> */}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center py-3">
                      No subscription plans found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {totalPages > 1 && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  page={page}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default VenderSubscriptions;